// Monitor elements for size changes and update CSS variables
let elementsToObserve = [
    { selector: '.jsSiteHeader', cssVar: '--siteHeaderHeight' },
    { selector: '.jsMobileGiveBtn', cssVar: '--mobileGiveBtnHeight' }
];

let resizeObserver = new ResizeObserver(entries => {
    for (let entry of entries) {
        let newHeight = entry.target.clientHeight;
        let cssVar = entry.target.dataset.cssVar;
        if (cssVar) {
            document.documentElement.style.setProperty(cssVar, newHeight + 'px');
        }
    }
});

for (let { selector, cssVar } of elementsToObserve) {
    let element = document.querySelector(selector);
    if (element) {
        element.dataset.cssVar = cssVar;
        resizeObserver.observe(element);
    }
}